import React from 'react';
import c from 'classnames';
import ListItem from '../../../../List/ListItem';
import { getDescendentId } from '../utils';
import s from './AutoCompleteMenu.scss';
const AutoCompleteMenu = ({ menuId, items, selectedIndex, onSelectItem })=>{
    return(// Since this is just the menu portion of an autocomplete pattern, we expect the consumer to handle root-level key events
    /*#__PURE__*/ React.createElement("div", {
        className: c('ds-surface-tertiary', s['root']),
        role: "listbox"
    }, items.map((item, index)=>/*#__PURE__*/ React.createElement(ListItem, {
            id: getDescendentId(menuId, index),
            key: index,
            role: "option",
            label: item.label,
            isSelected: selectedIndex === index,
            onClick: ()=>onSelectItem(item)
        }))));
};
AutoCompleteMenu.displayName = 'AutoCompleteMenu';
export default AutoCompleteMenu;
